import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Flex } from '@magnetic/flex';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import howToUseThisBaseSvg from '../../../../../assets/images/how-do-i-use-this-base.svg';
import howToUseThisPressedSvg from '../../../../../assets/images/how-do-i-use-this-pressed.svg';
import { getResetWidgets } from '../../../../../store/uislice';
export { default as LegacyHowToUseThis } from './legacy-how-to-use-this';
const Wrapper = styled.div `
  position: absolute;
  top: 1.1vw;
  right: 1.1vw;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 9999999999;

  @media (orientation: portrait) {
    top: 1.1vw;
    right: 1.1vw;
  }

  @media (max-width: 768px) and (orientation: portrait) {
    top: 0.9rem;
    right: 0.75rem;
  }
`;
const Trigger = styled.button `
  width: clamp(9.6rem, 9.45vw, 11.35rem);
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  position: relative;

  img {
    display: block;
    width: 100%;
    height: auto;
  }

  @media (orientation: portrait) {
    width: clamp(6.6rem, 18vw, 7.8rem);
  }

  @media (max-width: 768px) and (orientation: portrait) {
    width: clamp(6.8rem, 30vw, 8rem);
  }

  @media (max-width: 768px) and (orientation: landscape) {
    width: clamp(8.75rem, 34vw, 10rem);
  }
`;
const TriggerArtwork = styled.img `
  display: block;
  width: 100%;
  height: auto;
`;
const TriggerText = styled.div `
  position: absolute;
  top: 12%;
  right: 8%;
  min-width: fit-content;
  width: 52%;
  color: rgba(248, 244, 255, 0.92);
  font-family: 'Sora', sans-serif;
  font-size: clamp(0.98rem, 1vw, 1.1rem);
  font-weight: 900;
  text-shadow:
    0.02em 0 rgba(248, 244, 255, 0.92),
    -0.02em 0 rgba(248, 244, 255, 0.92),
    0 0.02em rgba(248, 244, 255, 0.92),
    0 -0.02em rgba(248, 244, 255, 0.92),
    0.03em 0 rgba(248, 244, 255, 0.92),
    -0.03em 0 rgba(248, 244, 255, 0.92);
  line-height: 0.96;
  letter-spacing: -0.03em;
  text-align: left;
  text-transform: uppercase;
  pointer-events: none;
  white-space: nowrap;
  font-size: 0.72vw;
  @media (orientation: portrait) {
    // font-size: clamp(0.62rem, 1.8vw, 0.78rem);
    width: 56%;
    top: 17%;
    right: 7%;
  }

  @media (max-width: 768px) and (orientation: portrait) {
    // font-size: clamp(0.64rem, 3vw, 0.78rem);
  }
`;
const Text = styled.div `
  font-size: clamp(0.56rem, 1vw, 1rem);
  font-family: 'Sora', sans-serif;
  color: white;
  line-height: 1.35;

  @media (max-width: 768px) {
    font-size: 0.68rem;
  }
`;
const Step = styled.div `
  display: grid;
  grid-template-columns: clamp(2.2rem, 2.9vw, 2.7rem) minmax(0, 1fr);
  align-items: center;
  column-gap: clamp(0.55rem, 0.9vw, 0.9rem);
  margin-top: clamp(0.5rem, 1vw, 0.85rem);
  width: 100%;

  &:first-child {
    margin-top: 0;
  }
`;
const StepIcon = styled.img `
  width: ${({ $variant }) => {
    if ($variant === 'pan') {
        return 'clamp(1.8rem, 2.8vw, 2.45rem)';
    }
    if ($variant === 'search') {
        return 'clamp(2rem, 3.1vw, 2.7rem)';
    }
    if ($variant === 'tap') {
        return 'clamp(1.5rem, 2.35vw, 2.05rem)';
    }
    return 'clamp(1.25rem, 2vw, 1.85rem)';
}};
  height: auto;
  display: block;
  justify-self: center;
`;
const StepText = styled(Text) `
  font-size: clamp(0.52rem, 0.52vw, 0.72rem);
`;
const StepFooter = styled(Flex) `
  margin-top: clamp(0.5rem, 1vw, 0.85rem);
  width: 100%;
`;
const StepsContainer = styled.div `
  width: clamp(12rem, 14.2vw, 16rem);
  padding: 1vw;
  margin-top: 0.6vw;
  border-radius: 0.8vw;
  z-index: 9999999999;
  background: linear-gradient(134.57deg, #212428 0%, #1d2024 99.26%);
  opacity: 0.95;
  box-shadow:
    0px 15.31px 11.83px 0px rgba(0, 0, 0, 0.0944),
    0px 41.2px 42.99px 0px rgba(0, 0, 0, 0.1167),
    0px 100px 163px 0px rgba(0, 0, 0, 0.19);

  @media (max-width: 768px) {
    width: min(13.5rem, calc(100vw - 1.5rem));
    margin-top: 0.45rem;
    padding: 0.75rem;
    border-radius: 0.75rem;
  }

  @media (orientation: portrait) {
    width: clamp(11rem, 28vw, 13rem);
  }
`;
const CloseButton = styled.button `
  background: black;
  padding: 0.4vw 1vw;
  border-radius: 0.2vw;
  border: 0;
  color: inherit;
  cursor: pointer;

  @media (max-width: 768px) {
    padding: 0.45rem 0.85rem;
    border-radius: 0.4rem;
  }
`;
const HowToUseThis = () => {
    const { t } = useTranslation();
    const [showSteps, setShowSteps] = useState(false);
    const resetWidgets = useSelector(getResetWidgets);
    useEffect(() => {
        if (resetWidgets > 0) {
            setShowSteps(false);
        }
    }, [resetWidgets]);
    return (_jsxs(Wrapper, Object.assign({ "aria-label": "How do I use this" }, { children: [_jsxs(Trigger, Object.assign({ id: "how_to_use_this_button", type: "button", "aria-expanded": showSteps, "aria-label": "How do I use this", onClick: () => setShowSteps((current) => !current) }, { children: [_jsx(TriggerArtwork, { src: showSteps ? howToUseThisPressedSvg : howToUseThisBaseSvg, alt: "How do I use this" }), _jsxs(TriggerText, { children: [t('floor.how-do-i'), _jsx("br", {}), t('floor.use-this')] })] })), showSteps && (_jsxs(StepsContainer, { children: [_jsxs(Step, { children: [_jsx(StepIcon, { "$variant": "pan", src: require('../../../../../assets/images/pan_n_rotate.png'), alt: "" }), _jsx(StepText, { children: t('floor.message-pan-rotate-zoom') })] }), _jsxs(Step, { children: [_jsx(StepIcon, { "$variant": "search", src: require('../../../../../assets/images/search.png'), alt: "" }), _jsx(StepText, { children: t('floor.message-use-room-finder') })] }), _jsxs(Step, { children: [_jsx(StepIcon, { "$variant": "tap", src: require('../../../../../assets/images/tap_on_meeting.png'), alt: "" }), _jsx(StepText, { children: t('floor.message-tap-on-meeting-room') })] }), _jsx(StepFooter, Object.assign({ justify: "center" }, { children: _jsx(CloseButton, Object.assign({ type: "button", onClick: () => setShowSteps(false) }, { children: _jsx(Text, Object.assign({ style: { fontSize: 'clamp(0.72rem, 0.72vw, 0.9rem)' } }, { children: t('floor.message-ok-got-it') })) })) }))] }))] })));
};
export default HowToUseThis;
